// extracted by mini-css-extract-plugin
module.exports = {"instagram":"TopInstagram_instagram__2GMWF"};